{
  "/customers/avangard-ulyanovsk.webp": {
    "width": 296,
    "height": 240,
    "base": "/generated-images/b927dbbeeccf92ff41134155",
    "widths": [
      192,
      296
    ]
  },
  "/customers/coats/q1089793.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/2ae593f8e25685059e6c5eb4",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1255190.webp": {
    "width": 133,
    "height": 160,
    "base": "/generated-images/d740293ef7eff6bd71ef6dd9",
    "widths": [
      133
    ]
  },
  "/customers/coats/q1255230.webp": {
    "width": 131,
    "height": 160,
    "base": "/generated-images/59c42906cb24bfaec6b6ca6e",
    "widths": [
      131
    ]
  },
  "/customers/coats/q1402861.webp": {
    "width": 93,
    "height": 160,
    "base": "/generated-images/3e263b04a54aa8f2377fc1c7",
    "widths": [
      93
    ]
  },
  "/customers/coats/q15190372.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/2732c313c3e4f894abc51683",
    "widths": [
      124
    ]
  },
  "/customers/coats/q15966495.webp": {
    "width": 143,
    "height": 160,
    "base": "/generated-images/150511227381c1082b7c217b",
    "widths": [
      143
    ]
  },
  "/customers/coats/q1651493.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/e58bef053b4d18f718a7750f",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1652004.webp": {
    "width": 106,
    "height": 160,
    "base": "/generated-images/7cd25691bd6e8a7a0e1284f0",
    "widths": [
      106
    ]
  },
  "/customers/coats/q1652041.webp": {
    "width": 107,
    "height": 160,
    "base": "/generated-images/2e3fca7f7ed0e9a6ae226385",
    "widths": [
      107
    ]
  },
  "/customers/coats/q1652535.webp": {
    "width": 106,
    "height": 160,
    "base": "/generated-images/bc466672248b2352fa00404c",
    "widths": [
      106
    ]
  },
  "/customers/coats/q1652618.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/32cc738e62aedb15bf6ee4cc",
    "widths": [
      129
    ]
  },
  "/customers/coats/q1652841.webp": {
    "width": 108,
    "height": 160,
    "base": "/generated-images/f5903bb5a17e2fdb242d36d0",
    "widths": [
      108
    ]
  },
  "/customers/coats/q1653028.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/8f6e4a1fadd2cbeadeb86f86",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1653589.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/c186055c08961b121637a1b8",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1653925.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/ab504eb416833dd5de2323af",
    "widths": [
      129
    ]
  },
  "/customers/coats/q1653957.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/1fafb174c9da004f5e49dbca",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1654438.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/4fd1fa45f76d277b1f414d2e",
    "widths": [
      127
    ]
  },
  "/customers/coats/q1654556.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/c10bdd964d2489b9e996ab9f",
    "widths": [
      127
    ]
  },
  "/customers/coats/q1654848.webp": {
    "width": 107,
    "height": 160,
    "base": "/generated-images/79a5ca4fad987fd775782cfa",
    "widths": [
      107
    ]
  },
  "/customers/coats/q1655740.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/8a3958f3bf3fcde4d74b3f54",
    "widths": [
      130
    ]
  },
  "/customers/coats/q1655777.webp": {
    "width": 137,
    "height": 160,
    "base": "/generated-images/8ba6e7d2286cabffe5749684",
    "widths": [
      137
    ]
  },
  "/customers/coats/q1655801.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/35c79c4f00cb30c5a6bde488",
    "widths": [
      127
    ]
  },
  "/customers/coats/q1655818.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/ec303706debd20574fe49c86",
    "widths": [
      127
    ]
  },
  "/customers/coats/q1655834.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/a0ef7eac9ab9c28de00306aa",
    "widths": [
      127
    ]
  },
  "/customers/coats/q1656139.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/89d3f0cdff915d4b15abed96",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1658596.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/ee8373997d1eefea3d5b8a7d",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1658607.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/25c598b731a5d5753fb2a357",
    "widths": [
      124
    ]
  },
  "/customers/coats/q1697.webp": {
    "width": 119,
    "height": 160,
    "base": "/generated-images/8c0dfeacc917ecb9d943f440",
    "widths": [
      119
    ]
  },
  "/customers/coats/q1753203.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/549b29301f52721858fbd49d",
    "widths": [
      129
    ]
  },
  "/customers/coats/q1759.webp": {
    "width": 132,
    "height": 160,
    "base": "/generated-images/c80084d33c6547ed645cd27c",
    "widths": [
      132
    ]
  },
  "/customers/coats/q17627375.webp": {
    "width": 170,
    "height": 160,
    "base": "/generated-images/877d5c983e77741993aea862",
    "widths": [
      170
    ]
  },
  "/customers/coats/q1778570.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/362734195389b7759c727844",
    "widths": [
      124
    ]
  },
  "/customers/coats/q1807671.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/2f1e82963122a1439fe0fd67",
    "widths": [
      128
    ]
  },
  "/customers/coats/q1875.webp": {
    "width": 161,
    "height": 160,
    "base": "/generated-images/c27a2c3939c3a842444c74d4",
    "widths": [
      161
    ]
  },
  "/customers/coats/q1884296.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/3763e036dc9859850b6cf89f",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2191.webp": {
    "width": 140,
    "height": 160,
    "base": "/generated-images/69bdfa609f37940a5fb06454",
    "widths": [
      140
    ]
  },
  "/customers/coats/q2217105.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/4717acabd88d90311fad59c1",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2217246.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/94f6495098257caa36464868",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2217621.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/e869182d9a45662677f83418",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2217673.webp": {
    "width": 123,
    "height": 160,
    "base": "/generated-images/b425666fa1e6b27ca7841296",
    "widths": [
      123
    ]
  },
  "/customers/coats/q2217934.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/4e5e3dad5c52b899ad5657fd",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2217962.webp": {
    "width": 136,
    "height": 160,
    "base": "/generated-images/7a8525b642af84ad5ce04953",
    "widths": [
      136
    ]
  },
  "/customers/coats/q2218114.webp": {
    "width": 123,
    "height": 160,
    "base": "/generated-images/e0416758c2753d679f703df1",
    "widths": [
      123
    ]
  },
  "/customers/coats/q2218202.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/1ab56196beea640fb9ef7b39",
    "widths": [
      130
    ]
  },
  "/customers/coats/q2218459.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/fc214cd5c62ac32550bfe944",
    "widths": [
      129
    ]
  },
  "/customers/coats/q2218553.webp": {
    "width": 133,
    "height": 160,
    "base": "/generated-images/67832e830eab8ef2caaf6db5",
    "widths": [
      133
    ]
  },
  "/customers/coats/q2218609.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/5b214d10fd39c3b2df4ae136",
    "widths": [
      129
    ]
  },
  "/customers/coats/q2220842.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/501c06f7b5f3502bd80862bf",
    "widths": [
      124
    ]
  },
  "/customers/coats/q2246.webp": {
    "width": 155,
    "height": 160,
    "base": "/generated-images/552647462a6229e1a6fe6f16",
    "widths": [
      155
    ]
  },
  "/customers/coats/q2263898.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/9791a3fda02814b2d0767aae",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2373743.webp": {
    "width": 100,
    "height": 126,
    "base": "/generated-images/21337a2e0fdb723614d35cdb",
    "widths": [
      100
    ]
  },
  "/customers/coats/q2387416.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/3e2055ef49828e3d0687055b",
    "widths": [
      124
    ]
  },
  "/customers/coats/q23898958.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/3c65237774f998a226da51e2",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2429108.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/3253ae00ff3be814abf7aab9",
    "widths": [
      130
    ]
  },
  "/customers/coats/q250512.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/917301dc3fbf913996df522f",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2534488.webp": {
    "width": 117,
    "height": 160,
    "base": "/generated-images/9981f3e93aee2148d4120904",
    "widths": [
      117
    ]
  },
  "/customers/coats/q257367.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/aa7c924de4b34e066df69081",
    "widths": [
      130
    ]
  },
  "/customers/coats/q2602523.webp": {
    "width": 126,
    "height": 160,
    "base": "/generated-images/87fee1c9f22de7f5217f3c0f",
    "widths": [
      126
    ]
  },
  "/customers/coats/q2607218.webp": {
    "width": 131,
    "height": 160,
    "base": "/generated-images/46fcfca517cc8e46289c41a2",
    "widths": [
      131
    ]
  },
  "/customers/coats/q2610877.webp": {
    "width": 135,
    "height": 160,
    "base": "/generated-images/43b2e5f246fdf7e764d0a627",
    "widths": [
      135
    ]
  },
  "/customers/coats/q261493.webp": {
    "width": 103,
    "height": 160,
    "base": "/generated-images/33a549d61283f835d4f381c1",
    "widths": [
      103
    ]
  },
  "/customers/coats/q2629594.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/8581072233c15304116137c2",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2629931.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/770becc24a204f0cef7b954e",
    "widths": [
      124
    ]
  },
  "/customers/coats/q2629937.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/d84ba83a0dd12175c99e4c92",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2629962.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/7783edac05f1dce8440afa94",
    "widths": [
      124
    ]
  },
  "/customers/coats/q2629989.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/a8a3dfcb76b145a5c3a2fb60",
    "widths": [
      124
    ]
  },
  "/customers/coats/q2638874.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/c62c0fb41671be70f3233c52",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2640717.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/b0b95292d44314e72472892d",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2654.webp": {
    "width": 229,
    "height": 160,
    "base": "/generated-images/59976bcbb15f7bd3d938a1b4",
    "widths": [
      192,
      229
    ]
  },
  "/customers/coats/q266987.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/1f6e579d3088c8aeca1b1d94",
    "widths": [
      129
    ]
  },
  "/customers/coats/q2702.webp": {
    "width": 160,
    "height": 160,
    "base": "/generated-images/63462638d97e2ef25bfbff44",
    "widths": [
      160
    ]
  },
  "/customers/coats/q2707123.webp": {
    "width": 120,
    "height": 160,
    "base": "/generated-images/a0d6e2dee9fc0fe1e28212ed",
    "widths": [
      120
    ]
  },
  "/customers/coats/q2708307.webp": {
    "width": 99,
    "height": 160,
    "base": "/generated-images/39732f95e3078e3e44ba1e4c",
    "widths": [
      99
    ]
  },
  "/customers/coats/q2708368.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/559a7640e3060a733c038d52",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2708373.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/9fb13975d7ba2a710e92ea16",
    "widths": [
      128
    ]
  },
  "/customers/coats/q2723481.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/0c3fbbcf8b0b4ff4fcd97977",
    "widths": [
      124
    ]
  },
  "/customers/coats/q2737400.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/118b8a512f5c7b7d1d39b7ea",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2737405.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/fc1ad611ef7e0c771af4647a",
    "widths": [
      129
    ]
  },
  "/customers/coats/q2753.webp": {
    "width": 153,
    "height": 160,
    "base": "/generated-images/9d0193f0dd52cf5ed301494c",
    "widths": [
      153
    ]
  },
  "/customers/coats/q27566181.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/9a70bcfd0d683a314f5f98a7",
    "widths": [
      127
    ]
  },
  "/customers/coats/q2810.webp": {
    "width": 153,
    "height": 160,
    "base": "/generated-images/afe911d71773e4495810a3a7",
    "widths": [
      153
    ]
  },
  "/customers/coats/q3085607.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/57f8e9f73d7c4ead0601afad",
    "widths": [
      128
    ]
  },
  "/customers/coats/q3129.webp": {
    "width": 118,
    "height": 160,
    "base": "/generated-images/b7a95b686a9c32a74c51c4f1",
    "widths": [
      118
    ]
  },
  "/customers/coats/q3159.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/ba05eccc1e35b8ed1762413f",
    "widths": [
      128
    ]
  },
  "/customers/coats/q3178.webp": {
    "width": 161,
    "height": 160,
    "base": "/generated-images/d624f33e5a91d33dd8ec2e37",
    "widths": [
      161
    ]
  },
  "/customers/coats/q3266281.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/6c1e80fc91a6ff55766c1978",
    "widths": [
      129
    ]
  },
  "/customers/coats/q3573.webp": {
    "width": 146,
    "height": 160,
    "base": "/generated-images/4ee00fff6304cb496a086409",
    "widths": [
      146
    ]
  },
  "/customers/coats/q3624930.webp": {
    "width": 135,
    "height": 160,
    "base": "/generated-images/2859ae6d117b82c74acc0d53",
    "widths": [
      135
    ]
  },
  "/customers/coats/q3680.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/c29594714d688bfa3c264fc5",
    "widths": [
      129
    ]
  },
  "/customers/coats/q368518.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/af1961db2cf15a149b8ebb0a",
    "widths": [
      128
    ]
  },
  "/customers/coats/q3812567.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/50c288238dc4eefd2c379e49",
    "widths": [
      127
    ]
  },
  "/customers/coats/q3830180.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/799b9684fcc22276535a7be8",
    "widths": [
      130
    ]
  },
  "/customers/coats/q3843630.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/f22bc1050a27d08e3718d831",
    "widths": [
      127
    ]
  },
  "/customers/coats/q3876924.webp": {
    "width": 105,
    "height": 160,
    "base": "/generated-images/b705b461e061dfb72630dd27",
    "widths": [
      105
    ]
  },
  "/customers/coats/q3881420.webp": {
    "width": 107,
    "height": 160,
    "base": "/generated-images/6317b98b316ab5eeca9fd88f",
    "widths": [
      107
    ]
  },
  "/customers/coats/q3901092.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/4e47af07c0456612887f73e2",
    "widths": [
      128
    ]
  },
  "/customers/coats/q394622.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/4187462603356b090af35e72",
    "widths": [
      130
    ]
  },
  "/customers/coats/q4006638.webp": {
    "width": 129,
    "height": 160,
    "base": "/generated-images/0760e31e1db005075e8112ca",
    "widths": [
      129
    ]
  },
  "/customers/coats/q40253.webp": {
    "width": 136,
    "height": 160,
    "base": "/generated-images/40b4ae2a81580618881074c5",
    "widths": [
      136
    ]
  },
  "/customers/coats/q4025627.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/aee180ce88d9ff57f35fffa2",
    "widths": [
      128
    ]
  },
  "/customers/coats/q4221641.webp": {
    "width": 95,
    "height": 160,
    "base": "/generated-images/5677177576c1942bc9208b4f",
    "widths": [
      95
    ]
  },
  "/customers/coats/q4223943.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/0ca21e7ed835886b77fb1cb6",
    "widths": [
      127
    ]
  },
  "/customers/coats/q4307263.webp": {
    "width": 131,
    "height": 160,
    "base": "/generated-images/2870431a4fffb9a225b0be59",
    "widths": [
      131
    ]
  },
  "/customers/coats/q4307501.webp": {
    "width": 194,
    "height": 160,
    "base": "/generated-images/8573ecc382f9869f366900d0",
    "widths": [
      192,
      194
    ]
  },
  "/customers/coats/q5207.webp": {
    "width": 136,
    "height": 160,
    "base": "/generated-images/36c685f2c61774e33733f5b8",
    "widths": [
      136
    ]
  },
  "/customers/coats/q5219.webp": {
    "width": 160,
    "height": 160,
    "base": "/generated-images/322b92070c014358cb797263",
    "widths": [
      160
    ]
  },
  "/customers/coats/q5334.webp": {
    "width": 93,
    "height": 160,
    "base": "/generated-images/2c37f023c3319ef58237dada",
    "widths": [
      93
    ]
  },
  "/customers/coats/q5340.webp": {
    "width": 145,
    "height": 160,
    "base": "/generated-images/ed76a0851b2310ed145b907a",
    "widths": [
      145
    ]
  },
  "/customers/coats/q5462.webp": {
    "width": 216,
    "height": 160,
    "base": "/generated-images/023fc5ed49859a36eba8e7da",
    "widths": [
      192,
      216
    ]
  },
  "/customers/coats/q558713.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/5061609f82a971ff9e008414",
    "widths": [
      128
    ]
  },
  "/customers/coats/q5634.webp": {
    "width": 169,
    "height": 160,
    "base": "/generated-images/32d4ee82bd4f9a6daeeb132a",
    "widths": [
      169
    ]
  },
  "/customers/coats/q5835.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/bfcb7186bc7315142c700ee1",
    "widths": [
      128
    ]
  },
  "/customers/coats/q600611.webp": {
    "width": 132,
    "height": 160,
    "base": "/generated-images/433855387ddde24dbc59aaed",
    "widths": [
      132
    ]
  },
  "/customers/coats/q617420.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/8db740b6ed35f6a0ad081662",
    "widths": [
      128
    ]
  },
  "/customers/coats/q6320.webp": {
    "width": 175,
    "height": 160,
    "base": "/generated-images/e98a333cd47657a2338a39ad",
    "widths": [
      175
    ]
  },
  "/customers/coats/q649.webp": {
    "width": 135,
    "height": 160,
    "base": "/generated-images/53a8e7d1df3ee8d141910ce7",
    "widths": [
      135
    ]
  },
  "/customers/coats/q656.webp": {
    "width": 149,
    "height": 160,
    "base": "/generated-images/57795d5523b1b15954c7dedc",
    "widths": [
      149
    ]
  },
  "/customers/coats/q6563.webp": {
    "width": 131,
    "height": 160,
    "base": "/generated-images/168d38f1463f589999e3af5e",
    "widths": [
      131
    ]
  },
  "/customers/coats/q854601.webp": {
    "width": 130,
    "height": 160,
    "base": "/generated-images/19e3fd0ac46d5e524363c6ae",
    "widths": [
      130
    ]
  },
  "/customers/coats/q918129.webp": {
    "width": 126,
    "height": 160,
    "base": "/generated-images/07c2353416ba5d1555efbd68",
    "widths": [
      126
    ]
  },
  "/customers/coats/q918201.webp": {
    "width": 128,
    "height": 160,
    "base": "/generated-images/c840b396bf1ce6d6364d02a0",
    "widths": [
      128
    ]
  },
  "/customers/coats/q918593.webp": {
    "width": 125,
    "height": 160,
    "base": "/generated-images/7e8fc830e8e52ea12c9f0eb8",
    "widths": [
      125
    ]
  },
  "/customers/coats/q918606.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/39135f088acb8e9b1cac4edc",
    "widths": [
      127
    ]
  },
  "/customers/coats/q919023.webp": {
    "width": 127,
    "height": 160,
    "base": "/generated-images/63cfadeacae45190104decd2",
    "widths": [
      127
    ]
  },
  "/customers/coats/q925845.webp": {
    "width": 125,
    "height": 160,
    "base": "/generated-images/95c099b3be9c2e52d842f909",
    "widths": [
      125
    ]
  },
  "/customers/coats/q940875.webp": {
    "width": 124,
    "height": 160,
    "base": "/generated-images/61e979cf3379f0ee7047072f",
    "widths": [
      124
    ]
  },
  "/customers/coats/q971307.webp": {
    "width": 98,
    "height": 160,
    "base": "/generated-images/2e40bfc4d2353290cc25eaac",
    "widths": [
      98
    ]
  },
  "/customers/fok-gorokhovets.webp": {
    "width": 339,
    "height": 240,
    "base": "/generated-images/e063cd033a7adc0b88de426b",
    "widths": [
      192,
      320,
      339
    ]
  },
  "/customers/grebnoy-kanal-don.webp": {
    "width": 240,
    "height": 240,
    "base": "/generated-images/6a216dfa5a40cc4b4d4fd5d8",
    "widths": [
      192,
      240
    ]
  },
  "/customers/sh-nika.webp": {
    "width": 152,
    "height": 166,
    "base": "/generated-images/f0155ffeb0554ce74c301225",
    "widths": [
      152
    ]
  },
  "/customers/sh1-arkhangelsk.webp": {
    "width": 170,
    "height": 189,
    "base": "/generated-images/2c83750fb5ee8cb8726087dc",
    "widths": [
      170
    ]
  },
  "/customers/sshor-35-rostov.webp": {
    "width": 422,
    "height": 240,
    "base": "/generated-images/d46ee0e1734de6466dcecf13",
    "widths": [
      192,
      320,
      422
    ]
  },
  "/equipment/smart-playground/01. Брусья гнутые двойные.webp": {
    "width": 1431,
    "height": 1262,
    "base": "/generated-images/f67c9305ae283da77d3b81c7",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1431
    ]
  },
  "/equipment/smart-playground/02. Воркаут.webp": {
    "width": 1600,
    "height": 757,
    "base": "/generated-images/13149c20ae909128153cb6fc",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/03. Двойной треугольник.webp": {
    "width": 1213,
    "height": 1699,
    "base": "/generated-images/541c737364bdb7e31bca6074",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1213
    ]
  },
  "/equipment/smart-playground/04. Двойные разноуровневые брусья.webp": {
    "width": 1600,
    "height": 972,
    "base": "/generated-images/2d4ba2829b11bed40d06e227",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/05. Жим ногами.webp": {
    "width": 1584,
    "height": 1228,
    "base": "/generated-images/948d825d4efa15661aec5966",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1584
    ]
  },
  "/equipment/smart-playground/06. Жим от груди.webp": {
    "width": 734,
    "height": 756,
    "base": "/generated-images/57e66e75df5d05ae96f20049",
    "widths": [
      192,
      320,
      480,
      640,
      734
    ]
  },
  "/equipment/smart-playground/07. Классический трехуровневый рукоход.webp": {
    "width": 1600,
    "height": 974,
    "base": "/generated-images/934be411c5cb7140346e5997",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/08. Комплекс из рук-зм., шв. ст., 5 турн. кл. хв.webp": {
    "width": 1600,
    "height": 1061,
    "base": "/generated-images/8a36cbf02bb0af6e4edf4cfc",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/09. Лавка с упорами.webp": {
    "width": 1600,
    "height": 1180,
    "base": "/generated-images/399c6e00afb0c2ba6e7ce22a",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/10. Многофункциональный комплекс.webp": {
    "width": 1600,
    "height": 1482,
    "base": "/generated-images/a481757bdaa908940593d6d7",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/11. Ограждение.webp": {
    "width": 1600,
    "height": 928,
    "base": "/generated-images/22b0d177769e31117a4cc5a2",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/12. Скамья.webp": {
    "width": 1600,
    "height": 1005,
    "base": "/generated-images/40672c4b9359092494bd1c7f",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/13. Тройной каскад турников.webp": {
    "width": 1600,
    "height": 909,
    "base": "/generated-images/3643bd589e6ab12edb5db466",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/smart-playground/14. Стойка баскетбольная.webp": {
    "width": 1034,
    "height": 1280,
    "base": "/generated-images/862066070878b3cc5e1f220a",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1034
    ]
  },
  "/equipment/smart-playground/Ограждение+воркаут.webp": {
    "width": 1600,
    "height": 793,
    "base": "/generated-images/dc09333c9064142d2d8b476a",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/1. Скамья двойная.webp": {
    "width": 1600,
    "height": 693,
    "base": "/generated-images/780496e5fc46b3d42217835c",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/10. Турник двойной низкий.webp": {
    "width": 1349,
    "height": 877,
    "base": "/generated-images/3dfa40af4c3f15cb9934f6f1",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1349
    ]
  },
  "/equipment/sport-platforms/11. Помост.webp": {
    "width": 1331,
    "height": 806,
    "base": "/generated-images/76530c7a11f9fd08dac1c8c8",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1331
    ]
  },
  "/equipment/sport-platforms/12. Турник регулируемый.webp": {
    "width": 822,
    "height": 1071,
    "base": "/generated-images/80a173542995ebc9aeefe233",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      822
    ]
  },
  "/equipment/sport-platforms/13. Брусья двойные.webp": {
    "width": 1600,
    "height": 844,
    "base": "/generated-images/c9df55470e947305a061380f",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/16. Разнохватовый турник.webp": {
    "width": 928,
    "height": 1240,
    "base": "/generated-images/6c0c193eb5b5b13471fe2560",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      928
    ]
  },
  "/equipment/sport-platforms/18. Жим лежа.webp": {
    "width": 1192,
    "height": 960,
    "base": "/generated-images/985d79f985506c26cc5e142a",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1192
    ]
  },
  "/equipment/sport-platforms/19. Эллиптический.webp": {
    "width": 1492,
    "height": 1372,
    "base": "/generated-images/5c3c5c520dcd68eae082f8b7",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1492
    ]
  },
  "/equipment/sport-platforms/2. Скамья пресс.webp": {
    "width": 1600,
    "height": 1044,
    "base": "/generated-images/618bbd7fe66d55ecc69d4edd",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/20. Рычажная тяга.webp": {
    "width": 1268,
    "height": 1020,
    "base": "/generated-images/ce8c0ca59eb935a14153c36b",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1268
    ]
  },
  "/equipment/sport-platforms/21. Гравитрон.webp": {
    "width": 920,
    "height": 856,
    "base": "/generated-images/939459e11bf0c822be771cb8",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      920
    ]
  },
  "/equipment/sport-platforms/23. Велоорбитрек.webp": {
    "width": 1600,
    "height": 1484,
    "base": "/generated-images/066aebd959f107595865cc91",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/24. Гиперэкстензия.webp": {
    "width": 1256,
    "height": 1008,
    "base": "/generated-images/8028fcb4760c7d512014bce6",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1256
    ]
  },
  "/equipment/sport-platforms/25. Шведская стенка с баскет щитом и кольцо.webp": {
    "width": 1028,
    "height": 1404,
    "base": "/generated-images/af89bae8b948f1284c614545",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1028
    ]
  },
  "/equipment/sport-platforms/26. Спортивный комплекс.webp": {
    "width": 1236,
    "height": 936,
    "base": "/generated-images/acbe36f45ba110d9ec4a25d4",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1236
    ]
  },
  "/equipment/sport-platforms/27. П-образный рукоход Змейка.webp": {
    "width": 1064,
    "height": 1140,
    "base": "/generated-images/683f3faa3916bba415df204a",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1064
    ]
  },
  "/equipment/sport-platforms/28. Рукоход.webp": {
    "width": 1600,
    "height": 985,
    "base": "/generated-images/3caf7a830093e3ac475326c0",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/29. Пресс-брусья.webp": {
    "width": 656,
    "height": 980,
    "base": "/generated-images/88e1610ced830f47f599f455",
    "widths": [
      192,
      320,
      480,
      640,
      656
    ]
  },
  "/equipment/sport-platforms/3. Скамья с линейками.webp": {
    "width": 1360,
    "height": 840,
    "base": "/generated-images/018d9ddf6cb6887ce309a5e0",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1360
    ]
  },
  "/equipment/sport-platforms/30. Велотренажер.webp": {
    "width": 1552,
    "height": 1212,
    "base": "/generated-images/f80673a9937f0e833f594bd6",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1552
    ]
  },
  "/equipment/sport-platforms/31. Жим вверх.webp": {
    "width": 1388,
    "height": 1096,
    "base": "/generated-images/6ebc01e675ac0a22cd3e19fd",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1388
    ]
  },
  "/equipment/sport-platforms/4. Стенд.webp": {
    "width": 876,
    "height": 980,
    "base": "/generated-images/3e0f6f84e57cbefe0ebd7294",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      876
    ]
  },
  "/equipment/sport-platforms/5. Прыжок в длину с места.webp": {
    "width": 1338,
    "height": 687,
    "base": "/generated-images/a56ea316ead9b5e2b69c5026",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1338
    ]
  },
  "/equipment/sport-platforms/6. Рывок гири.webp": {
    "width": 1200,
    "height": 776,
    "base": "/generated-images/6fa5d328a98c4f916b07478b",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1200
    ]
  },
  "/equipment/sport-platforms/7. Мишень круглая.webp": {
    "width": 1094,
    "height": 1018,
    "base": "/generated-images/61e2f8a5af2a7745234cb882",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1094
    ]
  },
  "/equipment/sport-platforms/8. Двойная разноуровневая скамья с линейками.webp": {
    "width": 1600,
    "height": 867,
    "base": "/generated-images/9d75c7904d85390082789ce6",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/sport-platforms/9. Тройной турник.webp": {
    "width": 1320,
    "height": 852,
    "base": "/generated-images/f2074464ac1d4909ed246e10",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1320
    ]
  },
  "/equipment/sport-platforms/Спортивная площадка.webp": {
    "width": 1600,
    "height": 960,
    "base": "/generated-images/834458927db5700c0e928105",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/trainers/01. Жим лежа.webp": {
    "width": 1192,
    "height": 960,
    "base": "/generated-images/985d79f985506c26cc5e142a",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1192
    ]
  },
  "/equipment/trainers/02. Жим вверх.webp": {
    "width": 1388,
    "height": 1096,
    "base": "/generated-images/6ebc01e675ac0a22cd3e19fd",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1388
    ]
  },
  "/equipment/trainers/03. Рычажная тяга.webp": {
    "width": 1540,
    "height": 1484,
    "base": "/generated-images/f1e9281574f08812f50e839b",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1540
    ]
  },
  "/equipment/trainers/04. Становая тяга.webp": {
    "width": 1600,
    "height": 1222,
    "base": "/generated-images/8a44e917bd50446e07f3fdf2",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/trainers/05. Гравитрон.webp": {
    "width": 920,
    "height": 856,
    "base": "/generated-images/939459e11bf0c822be771cb8",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      920
    ]
  },
  "/equipment/trainers/06. Гиперэкстензия.webp": {
    "width": 1256,
    "height": 1008,
    "base": "/generated-images/8028fcb4760c7d512014bce6",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1256
    ]
  },
  "/equipment/trainers/07. Мультиштанга.webp": {
    "width": 1580,
    "height": 1072,
    "base": "/generated-images/37181802043e0a618749fbc6",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1580
    ]
  },
  "/equipment/trainers/08. Велотренажер.webp": {
    "width": 1552,
    "height": 1212,
    "base": "/generated-images/f80673a9937f0e833f594bd6",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1552
    ]
  },
  "/equipment/trainers/09. Велоорбитрек.webp": {
    "width": 1600,
    "height": 1484,
    "base": "/generated-images/066aebd959f107595865cc91",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1600
    ]
  },
  "/equipment/trainers/10. Эллиптический.webp": {
    "width": 1492,
    "height": 1372,
    "base": "/generated-images/5c3c5c520dcd68eae082f8b7",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1492
    ]
  },
  "/hero-workout-blue-v2.webp": {
    "width": 1254,
    "height": 1254,
    "base": "/generated-images/041d881d7911f49e81d7fd1c",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1254
    ]
  },
  "/projects/besedino-01.webp": {
    "width": 1280,
    "height": 960,
    "base": "/generated-images/9087ce5f7bd7f66a0338c9a1",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280
    ]
  },
  "/projects/kozmodyemyanovka-01.webp": {
    "width": 1280,
    "height": 853,
    "base": "/generated-images/769d5668833ea0316788dfbf",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280
    ]
  },
  "/projects/makaryev-01.webp": {
    "width": 1242,
    "height": 790,
    "base": "/generated-images/6f3cb36c0c94479eec04ca98",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1242
    ]
  },
  "/projects/makaryev-02.webp": {
    "width": 1079,
    "height": 620,
    "base": "/generated-images/cbc471dbaf5a279b485d31be",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1079
    ]
  },
  "/projects/makaryev-03.webp": {
    "width": 1280,
    "height": 960,
    "base": "/generated-images/4f0c76d994d07fcccde239ca",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280
    ]
  },
  "/projects/ostrogozhsk-01.webp": {
    "width": 930,
    "height": 523,
    "base": "/generated-images/e92be0f7115d1352fafac3bf",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      930
    ]
  },
  "/projects/ostrogozhsk-02.webp": {
    "width": 1200,
    "height": 675,
    "base": "/generated-images/4b8c159002ebebad96fae4e0",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1200
    ]
  },
  "/projects/susanino-01.webp": {
    "width": 800,
    "height": 600,
    "base": "/generated-images/c04c689829a0e0b3b95f0b09",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      800
    ]
  },
  "/projects/susanino-02.webp": {
    "width": 800,
    "height": 600,
    "base": "/generated-images/4ac1f3c398741baef64e8f99",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      800
    ]
  },
  "/projects/suzemka-01.webp": {
    "width": 1351,
    "height": 1040,
    "base": "/generated-images/ac7340a428de8468f000f11b",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1351
    ]
  },
  "/projects/suzemka-02.webp": {
    "width": 1285,
    "height": 1003,
    "base": "/generated-images/32d5a9fbf1101a9bd9bd6d5f",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1285
    ]
  },
  "/projects/suzemka-03.webp": {
    "width": 1440,
    "height": 1920,
    "base": "/generated-images/76ed695d04a7587338484b5c",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1440
    ]
  },
  "/video-posters/04d731014d48596136528ea70cc4b5d3.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/ecee7ea498ffb499a2c8a453",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/08f7868d810d8507ef47eca5570b9687.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/aa4f882a0ceb9ab050d9b90a",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/0bbf8b248ac873941f81ba95cd6e0d80.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/4b84c02562df73458f2dfef9",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/198f52be38e5b2902bb40a490b779e60.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/8777c95f39dc71c492ad1125",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/1d6c7220b2723d245c20dfe43e97fb94.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/466afe0920975f98f9ed280e",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/1dda04d2896a691f5f85bc3de13ef68a.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/aa7e4581ea69630ffc27e817",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/216613c38ea2a8e6b13faa676e877eb1.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/7d66bc6c7d555d564528e438",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/26b115a3c7eab8e832f76f5b93f3a854.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/0f685288f12e341906e4fd1d",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/3cf584142e3e285c314f80ff08d3055c.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/9c5c302877980bdfc86d7de3",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/49563e0c091ec36be68716a923f0d4c7.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/6cac7491fa4a6e4e72bed5c4",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/4a3cf31735949a9fe0b17aafe177696b.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/2207929e976c6759be919319",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/4f345bc7081b89d0e52ccfcfbf483fb7.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/2b5881da9595454ed8b5872f",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/5290dc94068463025bae133f8aff1edc.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/4e7fb4a842d66d8b937eda20",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/5308f68e6d6d3440078867985e22d503.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/ec438a6b2b579cdc18ea9e5a",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/58532f0865bbba4909bb4b547eb5146c.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/ca3a2c8aaaddf1793bb57c06",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/626e421c5d95aa247f05b076de375bb0.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/64d366bf7ea3d48fa9978d38",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/76ac1a3d3ad03dbd31c773cb3c2ef14c.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/313f863cd98c2ecb2772e835",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/7a1e57755e4a40326e904cb74a3bcb6f.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/66c26f2a8bdcf56e320d8c02",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/7bdbc2c6222709a0e3e9813aaa6cb78d.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/0f189c6c3aaaaec4b157ac07",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/7c2f553cd2e3984042fcb1b15ae6ee0e.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/14f6bc4eb7c8a32d9617caeb",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/8a1270729175807b2bc25373eb1e2652.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/5f0666b0b297a47997af48be",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/8e83b1d1bcd019648406f8b1f7877660.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/f4311ac36d2920a8c611d5d1",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/9993d161fd14bc97ed2d9ec5cb2c3b08.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/d46805dd9cf19bf1ae490d58",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/aa44cfd7c78b9802d360086ba80171af.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/893494c52ac426d512db56d5",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/b08b6191574761e77f6532571654a84c.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/222bba2735f9b039da422e4b",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/be310f1ca03643acf064257ccb38f810.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/1345ab58dffa1a0f92427673",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/bedbbc2b782b65b51ffd034cb53ead81.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/a03e2e7cbd37effa41026faf",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/c3eb29d448259f767ac479a8ca640d9a.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/5ac07dc312dc09c537520b0f",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/d039311950e273ea2c43bd447023b9aa.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/13f2cc122cea4ccdbda9e565",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/dbb0c81e666735cb255ae553695cd2b7.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/a25dc93d49270eefbdbcfde9",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/dcdbe3b8926a30d7e1c52c3c48bcc74f.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/aa4ea9077740bfd5935d05a1",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/e31304e73f3c7b4b8649eec2177a6f2a.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/0fda9f6879df3f3ebbc0a285",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/e45782ebfe3caee9fd9c626929adab4f.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/ac55c70a67840d928b9ced70",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/e9fcc7a96110a888d291d3a0eb1cadd7.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/9a52df8fd1608a4a13a1def0",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/ef6f51db6cc382422e42bcff104bde93.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/fe4b9b4540c92a98c120fc48",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/video-posters/ef90d81eceedb9d64df7b9bcc473cdfa.jpg": {
    "width": 360,
    "height": 640,
    "base": "/generated-images/1c8cc28ad381931c74b0d76b",
    "widths": [
      192,
      320,
      360
    ]
  },
  "/video-posters/efd761808f90d969db5e8b1a0c686670.jpg": {
    "width": 640,
    "height": 360,
    "base": "/generated-images/d97ed686384619905a4e6cf0",
    "widths": [
      192,
      320,
      480,
      640
    ]
  },
  "/workout-1400.webp": {
    "width": 1400,
    "height": 1400,
    "base": "/generated-images/a10d185f517c49bbd7d42fee",
    "widths": [
      192,
      320,
      480,
      640,
      768,
      960,
      1280,
      1400
    ]
  }
}
